import React, { useState } from 'react';
import { Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import { Form, Button, Row, Col, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Alert } from "react-bootstrap";
import {
    resetAllQueuesFromAWSForCadTopology,
    GetAwsQueuesFromConfig,
    killAndTerminateAllInstances
  } from "../../../UserFunctions";
import { uploadTopologyFile } from './../../../../actions/closeLoop/topology/index';

// Modals
import ResetQueueConfirmationModal from './../resetQueues/ResetQueueModal';
import PropTypes from "prop-types";


function FileUpload(props) {
    const [ stopExecutionError, setStopExecutionError] = useState('');
    const [ topology, setTopology ] = useState(null);
    const [ description, setDescription ] = useState('');
    const [ resetQueueModal, setResetQueueModal ] = useState(false);
    const [buttonPushPopUp, setbuttonPushPopUp] = useState(false);
    const [awsQueues, setawsQueues] = useState([]);

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(e.target.files);
        const topologyFile = document.getElementById("topologyFile");
        const formPayload = new FormData();
        formPayload.append("description", description);
        formPayload.append("topology_file", topology);
        console.log(description);
        console.log(formPayload.get('description'));

        props.uploadFile(formPayload);

        topologyFile.value = '';
        setTopology(null);
        setDescription('')
    }

    const closeResetQueueModal = () => {
        setResetQueueModal(false);
    };

    const handleFileChange = (e) => {
        setTopology(e.target.files[0]);
    }

    const handleResetQueues = (e) => {
        console.log(e)
        setResetQueueModal(true);
    }

    const handleCloseKillandReset = () => {
        setbuttonPushPopUp(false);
        setStopExecutionError('')
      };

    const handleStopExecution = (e) => {
        console.log(e)
        setbuttonPushPopUp(true);
    }

    const handleKillandReset = () => {
        killAndTerminateAllInstances(
            "/aws/ec2/kill_and_terminate_all_instances_by_force"
        ).then((response) => {
            console.log("test pass")
            console.log(response)
            setStopExecutionError('')
            handleReset();
        }).catch(error =>{
            console.log("test fail")
            setStopExecutionError(error.response.data.message)
        });        
    };

    const handleReset = () => {
        GetAwsQueuesFromConfig("/get_aws_queues").then((response) => {
          console.log(awsQueues)
          setawsQueues(response.data.queues);
          for (var i = 0; i < response.data.queues.length; i++) {
            var payload = {
              queue_name: response.data.queues[i],
            };
            resetAllQueuesFromAWSForCadTopology(
              "/aws/sqs/remove_messages",
              payload
            );
          }
        });
        handleCloseKillandReset();
    };

    return (
        <>
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col md="6">
                        <Form.Label htmlFor="description">
                            Description
                        </Form.Label>
                        <Form.Control
                            as="input"
                            required
                            id="description"
                            value={description}
                            type="text"
                            onChange={ (e) => { setDescription(e.target.value) } }
                        >
                        </Form.Control>
                    </Col>
                </Row>
                <Row style={{ alignItems: "center" }}>
                    <Col md="6">
                        <Form.Label htmlFor="topologyFile">
                            Topology File
                        </Form.Label>
                        <Form.Control
                            as="input"
                            required
                            id="topologyFile"
                            onChange={(e) => { handleFileChange(e) }}
                            type="file"
                            accept="application/JSON"
                            aria-describedby="fileUploadHelpBlock"
                        >
                        </Form.Control>
                        <Form.Text>
                            Your file must be a valid json file, Make sure all fields are enclose
                            in double quotes
                        </Form.Text>
                    </Col>
                    <Col md="2">
                        <Button style={{backgroundColor: "#757AF7"}} type="submit">Upload</Button>
                    </Col>
                    <Col md="2" style={{display:"none"}}>
                        <Button
                            style={{backgroundColor: "#757AF7", display:"none"}}
                            className={ resetQueueModal ? 'disabled' : '' }
                            onClick={(e) => { handleResetQueues(e) }}
                        >
                            { resetQueueModal ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    Resetting..
                                </>
                            ) : "Reset Queues" }
                        </Button>
                    </Col>
                    <Col md="2" style={{display:"none"}}>>
                        <Button
                            style={{backgroundColor: "#757AF7"}}
                            onClick={(e) => { handleStopExecution(e) }}
                        >
                            Stop Execution
                        </Button>
                    </Col>
                </Row>
            </Form>
            { resetQueueModal ? (
                <ResetQueueConfirmationModal
                    show={resetQueueModal}
                    setClose={closeResetQueueModal}
                />) : undefined }

            {buttonPushPopUp ? (
                <Modal isOpen={true}>
                <ModalHeader
                    toggle={handleCloseKillandReset}
                    style={{ backgroundColor: "#757AF7" }}
                ></ModalHeader>
                {stopExecutionError? 
                    <Alert key="danger" variant="danger">
                        {stopExecutionError}
                    </Alert> : null}
                <ModalBody>
                    <p>
                        Do you want to stop the execution and kill & terminate all instances and reset
                        queues
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn"
                        style={{ marginLeft: "70%", backgroundColor: "#757AF7" }}
                        onClick={handleKillandReset}
                    >
                        Yes
                    </Button>
                    <Button
                    className="btn"
                    style={{ marginRight: "40%", backgroundColor: "red" }}
                    onClick={handleCloseKillandReset}
                    >
                    No
                    </Button>
                </ModalFooter>
                </Modal>
            ) : undefined}
        </>
    )
}

const mapDispatchToProps = (dispatch) => ({
    uploadFile: (payload) => dispatch(uploadTopologyFile(payload)),
});

FileUpload.propTypes = {
    uploadFile: PropTypes.func,
};

export default connect(undefined, mapDispatchToProps)(FileUpload);